export const ghMenusDictionary = [
  {
    key: 'field_settings',
    en: 'Field Settings',
    uk: 'Налаштування поля',
    de: 'Feldeinstellungen',
    fr: 'Paramètres du champ'
  },
  {
    key: 'field_configurator',
    en: 'Field Configurator',
    uk: 'Конфігуратор поля',
    de: 'Feldkonfigurator',
    fr: 'Configurateur de champ'
  },
  {
    key: 'field_style',
    en: 'Field Style',
    uk: 'Стиль поля',
    de: 'Feldstil',
    fr: 'Style du champ'
  },
  {
    key: 'delete_element',
    en: 'Delete element',
    uk: 'Видалити елемент',
    de: 'Element löschen',
    fr: 'Supprimer l\'élément'
  },
  {
    key: 'template_editor',
    en: 'Template Editor',
    uk: 'Редактор шаблонів',
    de: 'Vorlagen-Editor',
    fr: 'Éditeur de modèles'
  },
  {
    key: 'template_builder',
    en: 'Template Builder',
    uk: 'Конструктор шаблонів',
    de: 'Vorlagen-Builder',
    fr: 'Constructeur de modèles'
  },
  {
    key: 'copy',
    en: 'Copy',
    uk: 'Копіювати',
    de: 'Kopieren',
    fr: 'Copier'
  },
  {
    key: 'upgrade',
    en: 'Upgrade',
    uk: 'Оновити',
    de: 'Upgrade',
    fr: 'Mise à niveau'
  },
];
